import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'sanitize',
})
export class SanitizePipe implements PipeTransform {
    sanitizer = inject(DomSanitizer);
    transform(value: any, args?: DomSanitizerFun): any {
        if (args) {
            return this.sanitizer[args](value);
        } else {
            return value;
        }
    }
}
type DomSanitizerFun = 'bypassSecurityTrustHtml' | 'bypassSecurityTrustStyle' | 'bypassSecurityTrustScript' | 'bypassSecurityTrustUrl' | 'bypassSecurityTrustResourceUrl';